import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { COLOR_CONSTANTS } from "../../../helpers/Colors";

const LoaderV2 = () => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      mt={5}
    >
      <CircularProgress
        size={24}
        sx={{ color: COLOR_CONSTANTS["on-primary/variant"] }}
      />
    </Box>
  );
};

export default LoaderV2;
